import React, { useState, useEffect, Fragment } from 'react';
import {
    Row,
    Input,
    FormGroup,
    CustomInput,
    Button,
    ButtonGroup,
    Form,
    Modal,
    ModalBody,
    Label,
} from 'reactstrap';
import {
    Colxx,
    Separator,
} from '../../../../../components/common/CustomBootstrap';
import { AxiosAPI, getGroupID } from '../../../../../helpers/AxiosAPI';
import {
    gAPI_Property_List,
    pAPI_mews,
    gAPI_Ingetration,
    gAPI_Rooms
} from '../../../../../constants/APIs';
import CustomSelectInput from '../../../../../components/common/CustomSelectInput';
import Select from 'react-select';
import Validation from '../../../../../components/Validation';

let arr = [];
export default function MewsIntegration({ visible, toggle, id, locale }) {
    const [property, setProperty] = useState([]);
    const [open, setOpen] = useState(false);
    const [msg, setMsg] = useState([]);
    const [maskData, setMaskData] = useState({
        client: "",
        clientToken: "",
    });
    const [inputData, setInputData] = useState({
        GroupId: getGroupID(),
        Name: '',
        Properties: [],
        SessionTimeoutInSeconds: 600,
        DefaultLanguage: 'en-US',
        client: '',
        clientToken: '',
        HotelCode: '',
        RatePlanCode: '',
    });
    useEffect(() => {
        if (id !== undefined) {
            AxiosAPI({
                method: 'get',
                url: `${pAPI_mews}/${id}?group_id=${getGroupID()}`,
            })
                .then(res => {
                    setInputData({
                        ...inputData,
                        Name: res.data.name,
                        Properties: res.data.properties !== null ? [res.data.properties[0]] : [],
                        client: (res.data.channelDetails.client),
                        clientToken: (res.data.channelDetails.apiSecret),
                        HotelCode: res.data.channelDetails.hotelCode,
                        RatePlanCode: res.data.channelDetails.ratePlanCode,
                    });

                    setMaskData({
                        ...maskData,
                        client: mask(res.data.channelDetails.client),
                        clientToken: mask(res.data.channelDetails.apiSecret),
                    });
                })
                .catch(err => console.log('err', err));

            AxiosAPI({
                method: 'get',
                url: `${gAPI_Property_List}/?group_id=${getGroupID()}`,
            })
                .then(res => {
                    setProperty([...res.data]);
                })
                .catch(err => console.error(err));
        }
        else {
            AxiosAPI({
                method: 'get',
                url: `${gAPI_Property_List}/?group_id=${getGroupID()}`,
            })
                .then(res => {
                    setProperty([...res.data]);
                })
                .catch(err => console.error(err));
        }
    }, [id]);
    const mask = (value) => {
        let maskedValue = "";
        for (let i = 0; i < value.length - 2; i++) {
            maskedValue += "*";
        }
        return maskedValue + value.substring(value.length - 2, value.length);
    }

    const handleNameChange = e => {
        e.persist();
        setInputData({ ...inputData, Name: e.target.value });
    };

    const handleApiKeyChange = e => {
        e.persist();
        setMaskData({ ...maskData, client: mask(e.target.value) });
        setInputData({ ...inputData, client: e.target.value });

    };
    const handleclientTokenChange = e => {
        e.persist();
        setMaskData({ ...maskData, clientToken: mask(e.target.value) });
        setInputData({ ...inputData, clientToken: e.target.value });

    };
    const handleHotelCodeChange = e => {
        e.persist();
        setInputData({ ...inputData, HotelCode: e.target.value });

    };
    const handleRateplanCode = e => {
        e.persist();
        setInputData({ ...inputData, RatePlanCode: e.target.value });
    };
    const handleCheckChange = e => {
        if (e.target.checked) {
            setInputData({ ...inputData, Properties: [e.target.value] });
        }
        if (!e.target.checked) {
            setInputData({ ...inputData, Properties: [] });
        }
    };

    const handleSave = async () => {
        if (id !== undefined) {
            AxiosAPI({
                method: 'put',
                url: `${pAPI_mews}/${id}?group_id=${getGroupID()}`,
                data: inputData,
            }).then((res) => {
                if (res.data.HttpStatusCode !== undefined && res.data.HttpStatusCode === 400 && res.data.Messages !== undefined
                    && res.data.Messages !== null && res.data.Messages.length > 0) {
                    setMsg(res.data.Messages);
                    setOpen(true);
                }
                else {
                    toggle();
                    setTimeout(() => {
                        window.location.reload();
                    }, 300);
                }
            });
        } else {
            AxiosAPI({
                method: 'post',
                url: pAPI_mews,
                data: inputData,
            }).then((res) => {
                if (res.data.HttpStatusCode !== undefined && res.data.HttpStatusCode === 400 && res.data.Messages !== undefined
                    && res.data.Messages !== null && res.data.Messages.length > 0) {
                    setMsg(res.data.Messages);
                    setOpen(true);
                }
                else {
                    toggle();
                    setTimeout(() => {
                        window.location.reload();
                    }, 300);
                }
            });

        }
    };
    return (
        <Fragment>
            <Modal isOpen={visible} toggle={toggle}>
                <ModalBody>
                    <Row className="mb-4">
                        <Colxx xxs="12">
                            <div className="text-center">
                                <h6>Add Intregation</h6>
                                <Separator className="mb-3" />
                                <Form>
                                    <FormGroup>
                                        <Label>Intregation Name</Label>
                                        <Input
                                            type="text"
                                            name="IntregationName"
                                            onChange={handleNameChange}
                                            placeholder="Intregation Name"
                                            defaultValue={inputData.Name}
                                        />
                                    </FormGroup>
                                    <FormGroup>
                                        <Label>Client</Label>
                                        <Input
                                            type="text"
                                            name="client"
                                            onChange={handleApiKeyChange}
                                            placeholder="Client"
                                            defaultValue={maskData.client}
                                        />
                                    </FormGroup>
                                    <FormGroup>
                                        <Label>Configuration Id</Label>
                                        <Input
                                            type="text"
                                            name="configuration id"
                                            onChange={handleclientTokenChange}
                                            placeholder="configuration"
                                            defaultValue={maskData.clientToken}
                                        />
                                    </FormGroup>
                                    <FormGroup>
                                        <Label>Hotel Code</Label>
                                        <Input
                                            type="text"
                                            name="hotelCode"
                                            onChange={handleHotelCodeChange}
                                            placeholder="Hotel Code"
                                            defaultValue={inputData.HotelCode}
                                        />
                                    </FormGroup>
                                    <FormGroup>
                                        <Label>Rateplan Code</Label>
                                        <Input
                                            type="text"
                                            name="RatePlanCode"
                                            onChange={handleRateplanCode}
                                            placeholder="Rateplan Code"
                                            defaultValue={inputData.RatePlanCode}
                                        />
                                    </FormGroup>
                                    <FormGroup>
                                        <div style={{ padding: '0 20%' }}>
                                            {property.map((p, index) => {
                                                return (<CustomInput
                                                    key={p.id}
                                                    type="radio"
                                                    id={index}
                                                    label={p.name}
                                                    value={p.id}
                                                    name="property"
                                                    checked={p.id === inputData.Properties[0] ? true : false}
                                                    onChange={handleCheckChange}
                                                />)

                                            })}
                                        </div>
                                    </FormGroup>
                                </Form>
                                <ButtonGroup className="mb-2" style={{ marginTop: '20px' }}>
                                    {id === undefined ? (<Button color="primary" size="xs" onClick={handleSave}>
                                        Create New Intregation
                                    </Button>) : (<Button color="primary" size="xs" onClick={handleSave}>
                                        Update Intregation
                                    </Button>)}
                                    <Button size="xs" color="dark" outline onClick={toggle}>
                                        Cancel
                                    </Button>
                                </ButtonGroup>
                            </div>
                        </Colxx>
                    </Row>
                </ModalBody>
            </Modal>
            <Validation open={open} messages={msg} toggle={() => { setOpen(!open) }}></Validation>
        </Fragment>
    );
}